<sb-password-reset>
    <sb-stepper
      #stepperComponent
      class="tw-dark tw-w-full sm:tw-w-fit"
      colorScheme="login"
      [showCancelButton]="true"
      (canceled)="navigateToLogin()"
      [loading]="loading">
      <sb-stepper-tab [template]="templateRestoreCode" [tabTitle]="'lang.passwordReset.restoreCode' | translate" icon="securityCode">
      </sb-stepper-tab>
      <sb-stepper-tab [template]="templatePassword" [tabTitle]="'lang.passwordReset.password' | translate" icon="password">
      </sb-stepper-tab>
    </sb-stepper>

    <ng-template #templateRestoreCode>
      <div class="tw-w-full tw-relative tw-flex tw-flex-col tw-items-center">
        <form [formGroup]="formRestoreCode" class="tw-flex tw-flex-col tw-items-center tw-w-full tw-space-y-3">
          <div class="tw-w-full tw-flex tw-gap-2">
            <input class="tw-w-full tw-input placeholder:!tw-text-white" type="text" formControlName="username" id="username"
                   placeholder="Username"/>
            <button
              sb-button-secondary
              color="blue"
              class="tw-w-59"
              [disabled]="!Username.valid || requestingRestoreCode || restoreCodeRequestBlocked > 0"
              (click)="requestRestoreCode()">
              {{
                restoreCodeRequestBlocked < 1 ? ('lang.passwordReset.requestRestoreCode' | translate) : restoreCodeRequestBlocked + ' ' + ('lang.globals.secondsShort' | translate)
              }}
            </button>
          </div>

          <input class="tw-w-full tw-input placeholder:!tw-text-white " type="text" formControlName="code"
                   [placeholder]="'lang.passwordReset.restoreCode' | translate" id="code"/>
          <div class="tw-h-6 tw-w-full">
            <p *ngIf="showInboxHint" class="tw-text-sbGreen-500">
              {{'lang.passwordReset.inboxHint' | translate}}
            </p>
            <p *ngIf="isInvalidRestoreCode && !showInboxHint" class="tw-text-sbRed-500">
              {{'lang.passwordReset.securityCodeWarning' | translate}}.
            </p>
            <p *ngIf="Username.dirty && !Username.valid"
                 class="tw-text-sbRed-500">{{'lang.login.usernameWarning' | translate}}</p>
            <p *ngIf="RestoreCode.dirty && !RestoreCode.valid"
                 class="tw-text-sbRed-500">{{'lang.passwordReset.restoreCodeWarning' | translate}}</p>
          </div>
        </form>
      </div>
    </ng-template>

    <ng-template #templatePassword>
      <form [formGroup]="formPassword" class="tw-w-full tw-space-y-3">
        <input
          class="tw-w-full tw-input placeholder:!tw-text-white"
          type="password"
          formControlName="password"
          id="password"
          [placeholder]="'lang.passwordReset.password' | translate"
          autocomplete="new-password"
        />
        <input
          class="tw-w-full tw-input placeholder:!tw-text-white"
          type="password"
          formControlName="passwordCheck"
          id="passwordCheck"
          [placeholder]="'lang.passwordReset.passwordRepeat' | translate"
          autocomplete="new-password-repeat"
        />
        <div class="tw-w-full tw-text-sbRed-500">
          <p *ngIf="Password.dirty && PasswordCheck.dirty && matchingPassword === false">
            {{'lang.passwordReset.matchingPassword' | translate }}
          </p>
          <p *ngIf="errorMessage">
            {{errorMessage}}
          </p>
        </div>
      </form>
      <div class="tw-mt-5">
        <p class="tw-text-sbGray-300">{{'lang.passwordReset.pwInclude'|translate}}:</p>
        <sb-string-requirements
          (validated)="passwordRequirementsFulfilled = $event"
          [inputString]="Password.value"
          [requirements]="passwordRequirements"
          [showAsError]="showPasswordRequirementsAsError">
        </sb-string-requirements>
      </div>
    </ng-template>
</sb-password-reset>
